import React from 'react'

export const IconCopy = ({ isLoading, color = '#2990FB' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            d="M10.6666 0.666504H2.66659C1.93325 0.666504 1.33325 1.2665 1.33325 1.99984V11.3332H2.66659V1.99984H10.6666V0.666504ZM12.6666 3.33317H5.33325C4.59992 3.33317 3.99992 3.93317 3.99992 4.6665V13.9998C3.99992 14.7332 4.59992 15.3332 5.33325 15.3332H12.6666C13.3999 15.3332 13.9999 14.7332 13.9999 13.9998V4.6665C13.9999 3.93317 13.3999 3.33317 12.6666 3.33317ZM12.6666 13.9998H5.33325V4.6665H12.6666V13.9998Z"
            fill={isLoading ? '' : color}
        />
    </svg>
)

export const IconPdf = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1337_283)">
            <path
                d="M16.6666 1.66699H6.66663C5.74996 1.66699 4.99996 2.41699 4.99996 3.33366V13.3337C4.99996 14.2503 5.74996 15.0003 6.66663 15.0003H16.6666C17.5833 15.0003 18.3333 14.2503 18.3333 13.3337V3.33366C18.3333 2.41699 17.5833 1.66699 16.6666 1.66699ZM16.6666 13.3337H6.66663V3.33366H16.6666V13.3337ZM3.33329 5.00033H1.66663V16.667C1.66663 17.5837 2.41663 18.3337 3.33329 18.3337H15V16.667H3.33329V5.00033ZM13.3333 10.0003V7.50033C13.3333 7.04199 12.9583 6.66699 12.5 6.66699H10.8333V10.8337H12.5C12.9583 10.8337 13.3333 10.4587 13.3333 10.0003ZM11.6666 7.50033H12.5V10.0003H11.6666V7.50033ZM15 9.16699H15.8333V8.33366H15V7.50033H15.8333V6.66699H14.1666V10.8337H15V9.16699ZM8.33329 9.16699H9.16663C9.62496 9.16699 9.99996 8.79199 9.99996 8.33366V7.50033C9.99996 7.04199 9.62496 6.66699 9.16663 6.66699H7.49996V10.8337H8.33329V9.16699ZM8.33329 7.50033H9.16663V8.33366H8.33329V7.50033Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_1337_283">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

export const IconFlag = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_2103_3391)">
            <path
                d="M10.2998 4.99998L10.6332 6.66665H14.9998V11.6666H12.1998L11.8665 9.99998H5.83317V4.99998H10.2998ZM11.6665 3.33331H4.1665V17.5H5.83317V11.6666H10.4998L10.8332 13.3333H16.6665V4.99998H11.9998L11.6665 3.33331Z"
                fill="#787878"
            />
        </g>
        <defs>
            <clipPath id="clip0_2103_3391">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

export const IconTimer = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_2111_4458)">
            <path
                d="M9.99199 1.66663C5.39199 1.66663 1.66699 5.39996 1.66699 9.99996C1.66699 14.6 5.39199 18.3333 9.99199 18.3333C14.6003 18.3333 18.3337 14.6 18.3337 9.99996C18.3337 5.39996 14.6003 1.66663 9.99199 1.66663ZM10.0003 16.6666C6.31699 16.6666 3.33366 13.6833 3.33366 9.99996C3.33366 6.31663 6.31699 3.33329 10.0003 3.33329C13.6837 3.33329 16.667 6.31663 16.667 9.99996C16.667 13.6833 13.6837 16.6666 10.0003 16.6666ZM10.417 5.83329H9.16699V10.8333L13.542 13.4583L14.167 12.4333L10.417 10.2083V5.83329Z"
                fill="#787878"
            />
        </g>
        <defs>
            <clipPath id="clip0_2111_4458">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

export const IconHelp = ({ color = '#979797' }) => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="6" cy="6" r="5.5" stroke={color} />
        <path
            d="M3.90039 4.36695C3.90039 4.09923 3.98634 3.82869 4.15825 3.55533C4.33016 3.27915 4.58097 3.05088 4.91069 2.87052C5.24042 2.69016 5.62509 2.59998 6.06472 2.59998C6.47335 2.59998 6.83408 2.67607 7.14689 2.82825C7.4597 2.97761 7.70066 3.18192 7.86974 3.44119C8.04165 3.70046 8.1276 3.98227 8.1276 4.28663C8.1276 4.52618 8.07829 4.73613 7.97965 4.91649C7.88383 5.09685 7.76829 5.25326 7.63302 5.38571C7.50057 5.51534 7.26102 5.73516 6.91439 6.04515C6.81858 6.13252 6.74108 6.21002 6.6819 6.27765C6.62553 6.34247 6.58326 6.40306 6.55508 6.45942C6.5269 6.51297 6.50435 6.56792 6.48744 6.62428C6.47335 6.67783 6.45081 6.77364 6.41981 6.91173C6.36626 7.20482 6.19859 7.35136 5.91677 7.35136C5.77023 7.35136 5.64623 7.30345 5.54478 7.20764C5.44614 7.11182 5.39682 6.9695 5.39682 6.78069C5.39682 6.54397 5.43346 6.33965 5.50673 6.16774C5.58 5.99302 5.67723 5.84084 5.79841 5.7112C5.91959 5.57875 6.08304 5.42234 6.28877 5.24198C6.46913 5.08417 6.59876 4.96581 6.67767 4.8869C6.7594 4.80517 6.82703 4.71499 6.88058 4.61636C6.93694 4.51772 6.96512 4.41063 6.96512 4.29509C6.96512 4.06964 6.88058 3.87941 6.71149 3.72441C6.54522 3.56942 6.32963 3.49192 6.06472 3.49192C5.75473 3.49192 5.52646 3.57083 5.37992 3.72864C5.23337 3.88364 5.10937 4.11332 5.00792 4.41768C4.9121 4.73613 4.73033 4.89535 4.46261 4.89535C4.30479 4.89535 4.17093 4.8404 4.06102 4.73049C3.95394 4.61777 3.90039 4.49659 3.90039 4.36695ZM5.96327 8.99998C5.79136 8.99998 5.64059 8.94502 5.51096 8.83511C5.38414 8.72239 5.32073 8.56598 5.32073 8.36589C5.32073 8.18835 5.38273 8.03899 5.50673 7.91781C5.63073 7.79663 5.78291 7.73604 5.96327 7.73604C6.14081 7.73604 6.29017 7.79663 6.41136 7.91781C6.53254 8.03899 6.59313 8.18835 6.59313 8.36589C6.59313 8.56316 6.52972 8.71816 6.4029 8.83089C6.27608 8.94361 6.12954 8.99998 5.96327 8.99998Z"
            fill={color}
        />
    </svg>
)

export const IconDuplicate = ({ isLoading }) => (
    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            className="color_stroke"
            d="M9.3 5C9.3 7.37482 7.37482 9.3 5 9.3C2.62518 9.3 0.7 7.37482 0.7 5C0.7 2.62518 2.62518 0.7 5 0.7C7.37482 0.7 9.3 2.62518 9.3 5Z"
            stroke={isLoading ? '' : '#979797'}
            strokeWidth="1.4"
        />
        <path
            className="color_fill"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11 10C13.7614 10 16 7.76142 16 5C16 2.23858 13.7614 0 11 0C8.23858 0 6 2.23858 6 5C6 7.76142 8.23858 10 11 10Z"
            fill={isLoading ? '' : '#979797'}
        />
    </svg>
)

export const IconDelete = () => (
    <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            className="color_fill"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.25 0.777778H11V2.33333H0V0.777778H2.75L3.53571 0H7.46429L8.25 0.777778ZM2.35714 14C1.49286 14 0.785714 13.3 0.785714 12.4444V3.11111H10.2143V12.4444C10.2143 13.3 9.50714 14 8.64286 14H2.35714Z"
            fill="#979797"
        />
    </svg>
)

export const IconDomain = ({ color = '#979797' }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10 1.66663C5.40002 1.66663 1.66669 5.39996 1.66669 9.99996C1.66669 14.6 5.40002 18.3333 10 18.3333C14.6 18.3333 18.3334 14.6 18.3334 9.99996C18.3334 5.39996 14.6 1.66663 10 1.66663ZM3.33335 9.99996C3.33335 9.49163 3.40002 8.99163 3.50835 8.51663L7.49169 12.5V13.3333C7.49169 14.25 8.24169 15 9.15835 15V16.6083C5.88335 16.1916 3.33335 13.3916 3.33335 9.99996ZM14.9084 14.5C14.6917 13.825 14.075 13.3333 13.325 13.3333H12.4917V10.8333C12.4917 10.375 12.1167 9.99996 11.6584 9.99996H6.65835V8.33329H8.32502C8.78335 8.33329 9.15835 7.95829 9.15835 7.49996V5.83329H10.825C11.7417 5.83329 12.4917 5.08329 12.4917 4.16663V3.82496C14.9334 4.80829 16.6667 7.20829 16.6667 9.99996C16.6667 11.7333 15.9917 13.3166 14.9084 14.5Z"
            fill={color}
        />
    </svg>
)

export const IconAttention = () => (
    <svg width="21" height="17" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            className="color_fill"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.26827 14C0.498482 15.3333 1.46073 17 3.00033 17H18C19.5396 17 20.5019 15.3333 19.7321 14L12.2322 1.00968C11.4624 -0.323671 9.5379 -0.323672 8.76811 1.00968L1.26827 14ZM11.4969 13.002C11.4969 13.5525 11.0506 14.0015 10.5002 14.0015C9.94969 14.0015 9.50345 13.5525 9.50345 13.002C9.50345 12.4516 9.94969 12.0025 10.5002 12.0025C11.0506 12.0025 11.4969 12.4516 11.4969 13.002ZM10.5002 11.003C11.0506 11.003 11.4969 10.5568 11.4969 10.0063V7.00228C11.4969 6.45181 11.0506 6.00557 10.5002 6.00557C9.94969 6.00557 9.50345 6.45181 9.50345 7.00229V10.0063C9.50345 10.5568 9.94969 11.003 10.5002 11.003Z"
            fill="none"
        />
    </svg>
)

export const IconArrowDown = () => (
    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path className="color_stroke" d="M1 1L6 7V7L11 1" stroke="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const IconLogoFull = () => (
    <svg width="148" height="48" viewBox="0 0 148 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0)">
            <path
                className="color_fill"
                d="M18.631 41.5903H14.5844V24.0996H18.631V41.5903ZM19.0657 18.9828C19.0657 19.7409 18.8205 20.3429 18.33 20.7888C17.8395 21.2347 17.2598 21.4576 16.5909 21.4576C15.8998 21.4576 15.309 21.2347 14.8185 20.7888C14.328 20.3429 14.0827 19.7409 14.0827 18.9828C14.0827 18.2025 14.328 17.5894 14.8185 17.1435C15.309 16.6976 15.8998 16.4746 16.5909 16.4746C17.2598 16.4746 17.8395 16.6976 18.33 17.1435C18.8205 17.5894 19.0657 18.2025 19.0657 18.9828ZM23.2361 24.6682C24.0164 24.4452 25.0309 24.2334 26.2794 24.0327C27.5279 23.8321 28.9102 23.7318 30.4263 23.7318C31.8532 23.7318 33.046 23.9324 34.0047 24.3337C34.9634 24.7128 35.7215 25.259 36.2789 25.9724C36.8585 26.6636 37.2599 27.5108 37.4828 28.5141C37.7281 29.4951 37.8507 30.5764 37.8507 31.7581V41.5903H33.8041V32.3935C33.8041 31.4571 33.7372 30.6656 33.6034 30.019C33.4919 29.3502 33.2913 28.8151 33.0014 28.4138C32.7339 27.9902 32.3549 27.6892 31.8644 27.5108C31.3962 27.3102 30.8165 27.2098 30.1253 27.2098C29.6126 27.2098 29.0775 27.2433 28.5201 27.3102C27.9627 27.377 27.5502 27.4328 27.2827 27.4774V41.5903H23.2361V24.6682ZM42.0409 19.4845L46.0875 18.8156V24.0996H52.3079V27.4774H46.0875V34.6007C46.0875 36.0053 46.3105 37.0086 46.7564 37.6106C47.2023 38.2126 47.9603 38.5136 49.0305 38.5136C49.7662 38.5136 50.4128 38.4355 50.9702 38.2795C51.5499 38.1234 52.0069 37.9785 52.3414 37.8447L53.0102 41.0552C52.542 41.2559 51.9289 41.4566 51.1708 41.6572C50.4128 41.8802 49.521 41.9916 48.4954 41.9916C47.2469 41.9916 46.199 41.8244 45.3518 41.49C44.5268 41.1556 43.8691 40.6762 43.3786 40.052C42.8881 39.4054 42.5425 38.6362 42.3419 37.7444C42.1412 36.8303 42.0409 35.7935 42.0409 34.6342V19.4845ZM54.3985 32.9286C54.3985 31.3902 54.6215 30.0413 55.0674 28.882C55.5356 27.7226 56.1487 26.7639 56.9068 26.0059C57.6648 25.2255 58.5343 24.6459 59.5153 24.2668C60.4963 23.8655 61.4996 23.6649 62.5252 23.6649C64.9331 23.6649 66.8059 24.4118 68.1436 25.9056C69.5036 27.3993 70.1836 29.6289 70.1836 32.5942C70.1836 32.8171 70.1725 33.0735 70.1502 33.3633C70.1502 33.6309 70.139 33.8761 70.1168 34.0991H58.5789C58.6904 35.5037 59.1809 36.5962 60.0504 37.3765C60.9422 38.1346 62.2242 38.5136 63.8963 38.5136C64.8773 38.5136 65.7692 38.4244 66.5718 38.246C67.3967 38.0677 68.0433 37.8782 68.5115 37.6775L69.0466 40.9884C68.8236 41.0998 68.5115 41.2225 68.1102 41.3562C67.7311 41.4677 67.2852 41.568 66.7724 41.6572C66.282 41.7687 65.7469 41.8579 65.1672 41.9248C64.5875 41.9916 63.9967 42.0251 63.3947 42.0251C61.8563 42.0251 60.5186 41.8021 59.3815 41.3562C58.2445 40.888 57.3081 40.2526 56.5723 39.45C55.8366 38.6251 55.2903 37.6664 54.9336 36.5739C54.5769 35.4591 54.3985 34.244 54.3985 32.9286ZM66.137 31.1227C66.137 30.5653 66.059 30.0413 65.9029 29.5508C65.7469 29.0381 65.5128 28.6033 65.2006 28.2466C64.9108 27.8675 64.5429 27.5777 64.097 27.377C63.6734 27.1541 63.1606 27.0426 62.5586 27.0426C61.9344 27.0426 61.3881 27.1652 60.9199 27.4105C60.4517 27.6334 60.0504 27.9344 59.716 28.3135C59.4038 28.6925 59.1586 29.1272 58.9802 29.6177C58.8019 30.1082 58.6792 30.6099 58.6124 31.1227H66.137ZM83.8826 27.7449C83.5482 27.6334 83.08 27.522 82.478 27.4105C81.8984 27.2767 81.2184 27.2098 80.438 27.2098C79.9921 27.2098 79.5128 27.2544 79 27.3436C78.5095 27.4328 78.1639 27.5108 77.9632 27.5777V41.5903H73.9166V24.9357C74.697 24.6459 75.6668 24.3783 76.8262 24.1331C78.0078 23.8655 79.3121 23.7318 80.739 23.7318C81.0065 23.7318 81.3187 23.7541 81.6754 23.7986C82.0321 23.8209 82.3889 23.8655 82.7456 23.9324C83.1023 23.977 83.4479 24.0439 83.7823 24.1331C84.1167 24.2 84.3843 24.2668 84.585 24.3337L83.8826 27.7449ZM93.001 38.7477C94.2495 38.7477 95.1971 38.6808 95.8437 38.547V34.0657C95.6207 33.9988 95.2974 33.9319 94.8738 33.865C94.4502 33.7981 93.982 33.7647 93.4692 33.7647C93.0233 33.7647 92.5662 33.7981 92.098 33.865C91.6521 33.9319 91.2397 34.0545 90.8607 34.2329C90.5039 34.4112 90.2141 34.6676 89.9911 35.0021C89.7682 35.3142 89.6567 35.7155 89.6567 36.206C89.6567 37.1647 89.9577 37.8336 90.5597 38.2126C91.1616 38.5693 91.9754 38.7477 93.001 38.7477ZM92.6666 23.6649C94.0043 23.6649 95.1302 23.8321 96.0443 24.1665C96.9584 24.5009 97.683 24.9691 98.2181 25.5711C98.7755 26.1731 99.1657 26.9088 99.3886 27.7784C99.6339 28.6256 99.7565 29.562 99.7565 30.5876V41.189C99.1322 41.3228 98.1847 41.4789 96.9138 41.6572C95.6653 41.8579 94.2495 41.9582 92.6666 41.9582C91.6187 41.9582 90.66 41.8579 89.7905 41.6572C88.921 41.4566 88.1741 41.1333 87.5498 40.6874C86.9478 40.2415 86.4685 39.6618 86.1117 38.9483C85.7773 38.2349 85.6101 37.3542 85.6101 36.3063C85.6101 35.303 85.7996 34.4558 86.1786 33.7647C86.5799 33.0735 87.115 32.5161 87.7839 32.0925C88.4528 31.6466 89.2219 31.3345 90.0915 31.1561C90.9833 30.9555 91.9085 30.8551 92.8672 30.8551C93.3131 30.8551 93.7813 30.8886 94.2718 30.9555C94.7623 31 95.2863 31.0892 95.8437 31.223V30.5541C95.8437 30.0859 95.7879 29.64 95.6764 29.2164C95.565 28.7928 95.3643 28.4249 95.0745 28.1128C94.8069 27.7784 94.4391 27.522 93.9709 27.3436C93.5249 27.1652 92.9564 27.0761 92.2653 27.0761C91.3289 27.0761 90.4705 27.1429 89.6901 27.2767C88.9098 27.4105 88.2744 27.5666 87.7839 27.7449L87.2822 24.4675C87.795 24.2891 88.5419 24.1108 89.5229 23.9324C90.5039 23.7541 91.5518 23.6649 92.6666 23.6649ZM103.185 32.8617C103.185 31.5686 103.385 30.3646 103.787 29.2499C104.188 28.1128 104.757 27.1318 105.492 26.3069C106.25 25.4819 107.165 24.8354 108.235 24.3672C109.305 23.899 110.509 23.6649 111.847 23.6649C113.496 23.6649 115.057 23.9659 116.529 24.5678L115.659 27.8787C115.191 27.678 114.656 27.5108 114.054 27.377C113.474 27.2433 112.85 27.1764 112.181 27.1764C110.598 27.1764 109.394 27.678 108.569 28.6813C107.744 29.6623 107.332 31.0558 107.332 32.8617C107.332 34.6007 107.722 35.9831 108.502 37.0086C109.283 38.0119 110.598 38.5136 112.449 38.5136C113.14 38.5136 113.82 38.4467 114.489 38.3129C115.157 38.1791 115.737 38.0119 116.228 37.8113L116.796 41.1556C116.35 41.3785 115.67 41.5792 114.756 41.7575C113.864 41.9359 112.939 42.0251 111.98 42.0251C110.487 42.0251 109.182 41.8021 108.068 41.3562C106.975 40.888 106.061 40.2526 105.325 39.45C104.612 38.6251 104.077 37.6552 103.72 36.5404C103.363 35.4034 103.185 34.1771 103.185 32.8617ZM119.171 19.4845L123.218 18.8156V24.0996H129.438V27.4774H123.218V34.6007C123.218 36.0053 123.441 37.0086 123.887 37.6106C124.332 38.2126 125.09 38.5136 126.161 38.5136C126.896 38.5136 127.543 38.4355 128.1 38.2795C128.68 38.1234 129.137 37.9785 129.471 37.8447L130.14 41.0552C129.672 41.2559 129.059 41.4566 128.301 41.6572C127.543 41.8802 126.651 41.9916 125.626 41.9916C124.377 41.9916 123.329 41.8244 122.482 41.49C121.657 41.1556 120.999 40.6762 120.509 40.052C120.018 39.4054 119.673 38.6362 119.472 37.7444C119.271 36.8303 119.171 35.7935 119.171 34.6342V19.4845ZM147.073 24.0996C145.267 30.7436 143.171 36.7634 140.785 42.1589C140.339 43.1622 139.882 44.0205 139.414 44.734C138.946 45.4474 138.422 46.0383 137.842 46.5065C137.263 46.9747 136.616 47.3091 135.903 47.5097C135.189 47.7327 134.364 47.8442 133.428 47.8442C132.804 47.8442 132.179 47.7773 131.555 47.6435C130.953 47.5097 130.496 47.3648 130.184 47.2088L130.92 43.9648C131.722 44.2769 132.514 44.433 133.294 44.433C134.342 44.433 135.156 44.1766 135.735 43.6638C136.337 43.1733 136.861 42.4041 137.307 41.3562C136.036 38.9037 134.81 36.2283 133.629 33.3299C132.469 30.4315 131.432 27.3548 130.518 24.0996H134.832C135.055 25.036 135.323 26.0505 135.635 27.1429C135.97 28.2354 136.326 29.3502 136.705 30.4872C137.084 31.602 137.486 32.7168 137.909 33.8316C138.333 34.9463 138.756 35.9831 139.18 36.9418C139.894 34.9575 140.562 32.8506 141.187 30.621C141.811 28.3692 142.379 26.1954 142.892 24.0996H147.073Z"
                fill="none"
            />
            <path
                className="color_fill color_stroke"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.5415 2.87455C18.5269 2.81716 18.4698 2.78295 18.4134 2.79756C18.4059 2.79948 17.6506 2.99511 16.4286 2.99511C15.2097 2.99511 14.4797 2.79999 14.4726 2.79794C14.4165 2.78283 14.359 2.81652 14.3439 2.87391L14.2975 3.0493C14.2823 3.10669 14.3154 3.16575 14.3714 3.18138C14.401 3.18945 15.077 3.37316 16.2483 3.39071V8.60278C16.2483 8.66222 16.2953 8.71039 16.3534 8.71039H16.531C16.5891 8.71039 16.6362 8.66222 16.6362 8.60278V3.39033C17.7947 3.37034 18.4811 3.18983 18.5114 3.18176C18.5676 3.16665 18.6011 3.10784 18.5865 3.05045L18.5415 2.87455Z"
                fill="none"
                stroke="none"
                strokeWidth="0.780159"
            />
            <path
                className="color_fill color_stroke"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.0899459 21.4592C0.0325522 21.4445 -0.00165343 21.3875 0.0129512 21.331C0.0148729 21.3235 0.210498 20.5683 0.210498 19.3463C0.210498 18.1273 0.0153853 17.3973 0.0133356 17.3902C-0.00178154 17.3341 0.0319117 17.2767 0.0893054 17.2615L0.264689 17.2151C0.322083 17.2 0.381142 17.233 0.396772 17.2891C0.404843 17.3186 0.588554 17.9946 0.606105 19.1659H5.81817C5.87762 19.1659 5.92579 19.213 5.92579 19.271V19.4487C5.92579 19.5067 5.87762 19.5538 5.81817 19.5538H0.605721C0.585736 20.7123 0.405227 21.3987 0.397156 21.429C0.382039 21.4852 0.323236 21.5187 0.265842 21.5041L0.0899459 21.4592Z"
                fill="none"
                stroke="none"
                strokeWidth="0.780159"
            />
            <path
                className="color_fill color_stroke"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.39462 9.18763C3.36439 9.13669 3.38056 9.07215 3.4308 9.04256C3.43747 9.03861 4.10983 8.6429 4.9739 7.77883C5.83585 6.91689 6.21404 6.26276 6.21764 6.25627C6.2466 6.20593 6.31105 6.18913 6.36234 6.219L6.51919 6.31018C6.57048 6.34006 6.58888 6.40518 6.56028 6.45589C6.5451 6.48248 6.19699 7.0904 5.38118 7.93103L9.06666 11.6165C9.1087 11.6586 9.10948 11.7259 9.06841 11.767L8.94283 11.8925C8.90176 11.9336 8.83442 11.9328 8.79239 11.8908L5.10663 8.20504C4.2733 9.0101 3.6603 9.36782 3.63318 9.38353C3.58275 9.41258 3.51745 9.39472 3.48722 9.34378L3.39462 9.18763Z"
                fill="none"
                stroke="none"
                strokeWidth="0.780159"
            />
            <path
                className="color_fill color_stroke"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.36953 4.8613C8.3616 4.8026 8.40171 4.74951 8.45952 4.7419C8.4672 4.74087 9.24073 4.63933 10.3737 4.18157C11.5039 3.72493 12.1077 3.27058 12.1135 3.26601C12.1598 3.23099 12.2257 3.2407 12.2613 3.28825L12.37 3.43346C12.4056 3.48101 12.397 3.54814 12.3509 3.58364C12.3265 3.60219 11.7686 4.02576 10.6892 4.48081L12.6416 9.31335C12.6639 9.36847 12.6383 9.43076 12.5845 9.45251L12.4198 9.51905C12.3659 9.5408 12.3043 9.51377 12.282 9.45866L10.3294 4.62575C9.24772 5.04121 8.54368 5.13098 8.51258 5.13484C8.45481 5.14188 8.40168 5.09992 8.39376 5.04122L8.36953 4.8613Z"
                fill="none"
                stroke="none"
                strokeWidth="0.780159"
            />
            <path
                className="color_fill color_stroke"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.2631 35.4308C12.2281 35.4785 12.1623 35.4888 12.1155 35.4542C12.1092 35.4496 11.4822 34.9853 10.3492 34.5275C9.21903 34.0709 8.46914 33.9783 8.46175 33.9776C8.4041 33.9706 8.36345 33.9178 8.37091 33.8589L8.39356 33.6789C8.40102 33.62 8.45378 33.5776 8.51162 33.5842C8.54203 33.5877 9.23764 33.6706 10.3302 34.0931L12.2827 29.2606C12.305 29.2055 12.3666 29.1784 12.4205 29.2002L12.5852 29.2667C12.639 29.2885 12.6646 29.3508 12.6423 29.4059L10.6897 34.2388C11.7564 34.6913 12.3252 35.1158 12.3502 35.1346C12.3967 35.1697 12.4058 35.2368 12.3707 35.2845L12.2631 35.4308Z"
                fill="none"
                stroke="none"
                strokeWidth="0.780159"
            />
            <path
                className="color_fill color_stroke"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.6859 1.70603C25.6938 1.64733 25.6537 1.59423 25.5959 1.58663C25.5882 1.5856 24.8147 1.48406 23.6817 1.0263C22.5514 0.569661 21.9477 0.115308 21.9419 0.110735C21.8956 0.0757128 21.8297 0.0854313 21.7941 0.132972L21.6854 0.27819C21.6498 0.325732 21.6583 0.392869 21.7045 0.428366C21.7288 0.446914 22.2868 0.870487 23.3662 1.32553L21.4138 6.15808C21.3915 6.21319 21.4171 6.27548 21.4709 6.29724L21.6356 6.36377C21.6894 6.38553 21.7511 6.3585 21.7734 6.30338L23.726 1.47048C24.8077 1.88594 25.5117 1.97571 25.5428 1.97957C25.6006 1.9866 25.6537 1.94465 25.6616 1.88595L25.6859 1.70603Z"
                fill="none"
                stroke="none"
                strokeWidth="0.780159"
            />
            <path
                className="color_fill color_stroke"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.39462 29.5314C3.36439 29.5823 3.38056 29.6468 3.4308 29.6764C3.43747 29.6804 4.10983 30.0761 4.9739 30.9402C5.83585 31.8021 6.21404 32.4562 6.21764 32.4627C6.2466 32.5131 6.31105 32.5299 6.36234 32.5L6.51919 32.4088C6.57048 32.3789 6.58888 32.3138 6.56028 32.2631C6.5451 32.2365 6.19699 31.6286 5.38118 30.788L9.06666 27.1025C9.1087 27.0604 9.10948 26.9931 9.06841 26.952L8.94283 26.8264C8.90176 26.7854 8.83442 26.7862 8.79239 26.8282L5.10663 30.514C4.2733 29.7089 3.6603 29.3512 3.63318 29.3355C3.58275 29.3064 3.51745 29.3243 3.48722 29.3752L3.39462 29.5314Z"
                fill="none"
                stroke="none"
                strokeWidth="0.780159"
            />
            <path
                className="color_fill color_stroke"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M30.8158 1.87963C30.8668 1.8494 30.9313 1.86557 30.9609 1.91582C30.9648 1.92249 31.3605 2.59485 32.2246 3.45892C33.0866 4.32087 33.7407 4.69906 33.7472 4.70265C33.7975 4.73161 33.8143 4.79606 33.7844 4.84736L33.6933 5.00421C33.6634 5.0555 33.5983 5.07389 33.5476 5.0453C33.521 5.03012 32.9131 4.68201 32.0724 3.86619L28.3869 7.55168C28.3449 7.59371 28.2776 7.5945 28.2365 7.55343L28.1109 7.42784C28.0698 7.38678 28.0706 7.31944 28.1127 7.2774L31.7984 3.59164C30.9933 2.75831 30.6356 2.14532 30.6199 2.11819C30.5909 2.06776 30.6087 2.00246 30.6597 1.97224L30.8158 1.87963Z"
                fill="none"
                stroke="none"
                strokeWidth="0.780159"
            />
            <path
                className="color_fill color_stroke"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.06717 11.2374C2.00847 11.2295 1.95538 11.2696 1.94777 11.3274C1.94674 11.3351 1.8452 12.1086 1.38744 13.2416C0.930806 14.3718 0.476453 14.9755 0.47188 14.9814C0.436858 15.0277 0.446576 15.0936 0.494118 15.1292L0.639335 15.2379C0.686877 15.2735 0.754014 15.2649 0.789511 15.2188C0.808059 15.1944 1.23163 14.6365 1.68668 13.557L6.51922 15.5095C6.57434 15.5318 6.63663 15.5062 6.65839 15.4524L6.72492 15.2877C6.74667 15.2338 6.71964 15.1721 6.66453 15.1499L1.83162 13.1973C2.24708 12.1156 2.33685 11.4116 2.34071 11.3805C2.34775 11.3227 2.30579 11.2696 2.24709 11.2616L2.06717 11.2374Z"
                fill="none"
                stroke="none"
                strokeWidth="0.780159"
            />
            <path
                className="color_fill color_stroke"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M34.3315 10.0541C34.3902 10.0461 34.4433 10.0862 34.4509 10.1441C34.4519 10.1517 34.5535 10.9253 35.0112 12.0583C35.4679 13.1885 35.9222 13.7922 35.9268 13.798C35.9618 13.8444 35.9521 13.9103 35.9046 13.9458L35.7593 14.0546C35.7118 14.0901 35.6447 14.0816 35.6092 14.0355C35.5906 14.0111 35.167 13.4531 34.712 12.3737L29.8795 14.3262C29.8243 14.3484 29.7621 14.3228 29.7403 14.269L29.6738 14.1043C29.652 14.0505 29.679 13.9888 29.7342 13.9665L34.5671 12.0139C34.1516 10.9323 34.0618 10.2282 34.058 10.1971C34.0509 10.1393 34.0929 10.0862 34.1516 10.0783L34.3315 10.0541Z"
                fill="none"
                stroke="none"
                strokeWidth="0.780159"
            />
            <path
                className="color_fill color_stroke"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.494081 23.5881C0.446353 23.6232 0.436019 23.6889 0.470706 23.7358C0.475301 23.742 0.9396 24.369 1.39736 25.502C1.854 26.6322 1.94654 27.3821 1.94731 27.3895C1.9543 27.4471 2.00706 27.4878 2.06595 27.4803L2.24596 27.4577C2.30485 27.4502 2.34723 27.3975 2.34071 27.3396C2.33713 27.3092 2.25423 26.6136 1.83173 25.521L6.66427 23.5685C6.71939 23.5463 6.74642 23.4846 6.72466 23.4307L6.65813 23.2661C6.63637 23.2122 6.57408 23.1866 6.51897 23.2089L1.68607 25.1615C1.23355 24.0948 0.809052 23.526 0.790222 23.501C0.755153 23.4545 0.688066 23.4455 0.640337 23.4805L0.494081 23.5881Z"
                fill="none"
                stroke="none"
                strokeWidth="0.780159"
            />
        </g>
        <defs>
            <clipPath id="clip0">
                <rect width="148" height="48" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

export const IconCheckMark = () => (
    <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            className="color_stroke"
            d="M1.38477 3.34277L4.76775 6.46826L9.38477 1"
            stroke="none"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const IconCross = () => (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            className="color_stroke--1"
            d="M1.66314 1L15.8737 15"
            stroke="none"
            strokeWidth="2"
            strokeLinecap="round"
        />
        <path
            className="color_stroke--1"
            d="M15.3369 1L1.12633 15"
            stroke="none"
            strokeWidth="2"
            strokeLinecap="round"
        />
    </svg>
)

export const IconStopHand = () => (
    <svg width="56" height="60" viewBox="0 0 56 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            className="color_fill--1"
            d="M55.5 13.75V50C55.5 55.5 51 60 45.5 60H27.25C24.55 60 22 58.925 20.125 57.025L0.5 37.075C0.5 37.075 3.65 34 3.75 33.95C4.3 33.475 4.975 33.225 5.725 33.225C6.275 33.225 6.775 33.375 7.225 33.625C7.325 33.65 18 39.775 18 39.775V10C18 7.925 19.675 6.25 21.75 6.25C23.825 6.25 25.5 7.925 25.5 10V27.5H28V3.75C28 1.675 29.675 0 31.75 0C33.825 0 35.5 1.675 35.5 3.75V27.5H38V6.25C38 4.175 39.675 2.5 41.75 2.5C43.825 2.5 45.5 4.175 45.5 6.25V27.5H48V13.75C48 11.675 49.675 10 51.75 10C53.825 10 55.5 11.675 55.5 13.75Z"
            fill="none"
        />
    </svg>
)

export const IconClose = () => (
    <svg width="22" height="22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3.929 3.929L18.07 18.07M18.071 3.929L3.93 18.07" />
        </g>
    </svg>
)

export const IconSearch = () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6Z"
            stroke="#979797"
        />
        <path d="M9.91309 9.91309L13.5 13.5" stroke="#979797" strokeLinecap="round" />
    </svg>
)

export const IconDetails = () => (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle className="bg" cx="11" cy="11" r="10.5" fill="#979797" stroke="white" />
        <circle cx="7" cy="11" r="1" fill="white" />
        <circle cx="11" cy="11" r="1" fill="white" />
        <circle cx="15" cy="11" r="1" fill="white" />
    </svg>
)

export const IconSelect = ({ style }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
            fill="#2990FB"
        />
        <path
            d="M6.15137 9.99994L9.37463 13.1249L14.0838 7.34952"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const IconUnselect = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="9.5" fill="white" stroke="#979797" />
    </svg>
)

export const IconTrash = () => (
    <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.25 0.777778H11V2.33333H0V0.777778H2.75L3.53571 0H7.46429L8.25 0.777778ZM2.35714 14C1.49286 14 0.785714 13.3 0.785714 12.4444V3.11111H10.2143V12.4444C10.2143 13.3 9.50714 14 8.64286 14H2.35714Z"
            fill="#979797"
        />
    </svg>
)

export const IconZoom = () => (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="11" cy="11" r="10.5" fill="#979797" stroke="white" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.6213 18.3787L19.6363 18.3636L18.636 17.3634L18.6353 17.3626L18.6311 17.3584L18.6301 17.3574L15.328 14.0553C15.9617 13.1676 16.3333 12.0831 16.3333 10.9167C16.3333 7.925 13.9083 5.5 10.9167 5.5C7.925 5.5 5.5 7.925 5.5 10.9167C5.5 13.9083 7.925 16.3333 10.9167 16.3333C12.083 16.3333 13.1675 15.9618 14.0552 15.3281L17.3586 18.6316L17.3627 18.6357L17.3635 18.6364L18.3635 19.6364L18.3787 19.6213L18.8333 20.075L20.075 18.8333L19.6213 18.3787ZM7.16667 10.9167C7.16667 12.9917 8.84167 14.6667 10.9167 14.6667C12.9917 14.6667 14.6667 12.9917 14.6667 10.9167C14.6667 8.84167 12.9917 7.16667 10.9167 7.16667C8.84167 7.16667 7.16667 8.84167 7.16667 10.9167Z"
            fill="white"
        />
        <path
            d="M13.0002 11.3334H11.3335V13H10.5002V11.3334H8.8335V10.5H10.5002V8.83337H11.3335V10.5H13.0002V11.3334Z"
            fill="white"
        />
    </svg>
)

export const IconTriangleBottom = () => (
    <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path className="color_fill--1" fillRule="evenodd" clipRule="evenodd" d="M4 5L8 0H0L4 5Z" fill="none" />
    </svg>
)

export const IconWarningTriangle = () => (
    <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            className="color_fill--1"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.270925 13.9903C-0.498861 15.3237 0.463389 16.9903 2.00298 16.9903H17.0027C18.5423 16.9903 19.5045 15.3237 18.7347 13.9903L11.2349 1.00001C10.4651 -0.333337 8.54056 -0.333338 7.77076 1.00001L0.270925 13.9903ZM10.4995 12.9924C10.4995 13.5428 10.0533 13.9919 9.50282 13.9919C8.95235 13.9919 8.5061 13.5428 8.5061 12.9924C8.5061 12.4419 8.95235 11.9929 9.50282 11.9929C10.0533 11.9929 10.4995 12.4419 10.4995 12.9924ZM9.50282 10.9934C10.0533 10.9934 10.4995 10.5471 10.4995 9.99665V6.99262C10.4995 6.44215 10.0533 5.9959 9.50282 5.9959C8.95235 5.9959 8.5061 6.44215 8.5061 6.99262V9.99665C8.5061 10.5471 8.95235 10.9934 9.50282 10.9934Z"
            fill="#ffca63"
        />
    </svg>
)

export const IconRename = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.3417 4.83177L14.3333 3.82344C13.6833 3.17344 12.625 3.17344 11.975 3.82344L9.74167 6.05677L2.5 13.2984V16.6651H5.86667L13.15 9.38177L15.3417 7.1901C16 6.5401 16 5.48177 15.3417 4.83177ZM5.175 14.9984H4.16667V13.9901L11.3833 6.77344L12.3917 7.78177L5.175 14.9984ZM9.16667 16.6651L12.5 13.3318H17.5V16.6651H9.16667Z"
            fill="#979797"
        />
    </svg>
)

export const EditMembers = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.50033 11.4596C5.55033 11.4596 1.66699 12.4346 1.66699 14.3763V15.8346H13.3337V14.3763C13.3337 12.4346 9.45033 11.4596 7.50033 11.4596ZM3.61699 14.168C4.31699 13.6846 6.00866 13.1263 7.50033 13.1263C8.99199 13.1263 10.6837 13.6846 11.3837 14.168H3.61699ZM7.50033 10.0013C9.10866 10.0013 10.417 8.69297 10.417 7.08464C10.417 5.4763 9.10866 4.16797 7.50033 4.16797C5.89199 4.16797 4.58366 5.4763 4.58366 7.08464C4.58366 8.69297 5.89199 10.0013 7.50033 10.0013ZM7.50033 5.83464C8.19199 5.83464 8.75033 6.39297 8.75033 7.08464C8.75033 7.7763 8.19199 8.33464 7.50033 8.33464C6.80866 8.33464 6.25033 7.7763 6.25033 7.08464C6.25033 6.39297 6.80866 5.83464 7.50033 5.83464ZM13.367 11.5096C14.3337 12.2096 15.0003 13.143 15.0003 14.3763V15.8346H18.3337V14.3763C18.3337 12.693 15.417 11.7346 13.367 11.5096V11.5096ZM12.5003 10.0013C14.1087 10.0013 15.417 8.69297 15.417 7.08464C15.417 5.4763 14.1087 4.16797 12.5003 4.16797C12.0503 4.16797 11.6337 4.2763 11.2503 4.45964C11.7753 5.2013 12.0837 6.10964 12.0837 7.08464C12.0837 8.05964 11.7753 8.96797 11.2503 9.70964C11.6337 9.89297 12.0503 10.0013 12.5003 10.0013Z"
            fill="#979797"
        />
    </svg>
)

export const IconMove = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.0007 3.3335L8.82565 4.5085L13.4757 9.16683H3.33398V10.8335H13.4757L8.82565 15.4918L10.0007 16.6668L16.6673 10.0002L10.0007 3.3335Z"
            fill="#898989"
        />
    </svg>
)

export const IconNext = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11 8L11.3536 8.35355C11.5488 8.15829 11.5488 7.84171 11.3536 7.64645L11 8ZM5.64645 12.6464C5.45118 12.8417 5.45118 13.1583 5.64645 13.3536C5.84171 13.5488 6.15829 13.5488 6.35355 13.3536L5.64645 12.6464ZM6.35355 2.64645C6.15829 2.45118 5.84171 2.45118 5.64645 2.64645C5.45118 2.84171 5.45118 3.15829 5.64645 3.35355L6.35355 2.64645ZM10.6464 7.64645L5.64645 12.6464L6.35355 13.3536L11.3536 8.35355L10.6464 7.64645ZM5.64645 3.35355L10.6464 8.35355L11.3536 7.64645L6.35355 2.64645L5.64645 3.35355Z"
            fill="#5F5F5F"
        />
    </svg>
)

export const IconVisible = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.0017 5.71373C12.7088 5.71373 15.1231 7.23516 16.3017 9.6423C15.1231 12.0494 12.7088 13.5709 10.0017 13.5709C7.29453 13.5709 4.88025 12.0494 3.70167 9.6423C4.88025 7.23516 7.29453 5.71373 10.0017 5.71373ZM10.0017 4.28516C6.43024 4.28516 3.38025 6.50658 2.14453 9.6423C3.38025 12.778 6.43024 14.9994 10.0017 14.9994C13.5731 14.9994 16.6231 12.778 17.8588 9.6423C16.6231 6.50658 13.5731 4.28516 10.0017 4.28516ZM10.0017 7.85658C10.9874 7.85658 11.7874 8.65658 11.7874 9.6423C11.7874 10.628 10.9874 11.428 10.0017 11.428C9.01596 11.428 8.21596 10.628 8.21596 9.6423C8.21596 8.65658 9.01596 7.85658 10.0017 7.85658ZM10.0017 6.42801C8.23024 6.42801 6.78739 7.87087 6.78739 9.6423C6.78739 11.4137 8.23024 12.8566 10.0017 12.8566C11.7731 12.8566 13.216 11.4137 13.216 9.6423C13.216 7.87087 11.7731 6.42801 10.0017 6.42801Z"
            fill="#979797"
        />
    </svg>
)
export const IconHidden = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.0017 5.7154C12.7088 5.7154 15.1231 7.23683 16.3017 9.64397C15.8802 10.5154 15.2874 11.2654 14.5802 11.8725L15.5874 12.8797C16.5802 12.0011 17.366 10.9011 17.8588 9.64397C16.6231 6.50826 13.5731 4.28683 10.0017 4.28683C9.09453 4.28683 8.2231 4.42969 7.40167 4.69397L8.58024 5.87254C9.04453 5.77969 9.51596 5.7154 10.0017 5.7154ZM9.23739 6.52969L10.716 8.00826C11.1231 8.18683 11.4517 8.5154 11.6302 8.92254L13.1088 10.4011C13.166 10.1583 13.2088 9.90112 13.2088 9.63683C13.216 7.8654 11.7731 6.42969 10.0017 6.42969C9.73739 6.42969 9.48739 6.4654 9.23739 6.52969ZM2.86596 4.19397L4.78025 6.10826C3.61596 7.02254 2.69453 8.23683 2.14453 9.64397C3.38025 12.7797 6.43024 15.0011 10.0017 15.0011C11.0874 15.0011 12.1302 14.794 13.0874 14.4154L15.5302 16.8583L16.5374 15.8511L3.8731 3.17969L2.86596 4.19397ZM8.2231 9.55112L10.0874 11.4154C10.0588 11.4225 10.0302 11.4297 10.0017 11.4297C9.01596 11.4297 8.21596 10.6297 8.21596 9.64397C8.21596 9.60826 8.2231 9.58683 8.2231 9.55112V9.55112ZM5.79453 7.12254L7.04453 8.37255C6.88024 8.7654 6.78739 9.19397 6.78739 9.64397C6.78739 11.4154 8.23024 12.8583 10.0017 12.8583C10.4517 12.8583 10.8802 12.7654 11.266 12.6011L11.966 13.3011C11.3374 13.4725 10.6802 13.5725 10.0017 13.5725C7.29453 13.5725 4.88025 12.0511 3.70167 9.64397C4.20167 8.62254 4.93025 7.77969 5.79453 7.12254Z"
            fill="#979797"
        />
    </svg>
)

export const IconHiddenPurple = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12 5.99922C15.79 5.99922 19.17 8.12922 20.82 11.4992C20.23 12.7192 19.4 13.7692 18.41 14.6192L19.82 16.0292C21.21 14.7992 22.31 13.2592 23 11.4992C21.27 7.10922 17 3.99922 12 3.99922C10.73 3.99922 9.51 4.19922 8.36 4.56922L10.01 6.21922C10.66 6.08922 11.32 5.99922 12 5.99922ZM10.93 7.13922L13 9.20922C13.57 9.45922 14.03 9.91922 14.28 10.4892L16.35 12.5592C16.43 12.2192 16.49 11.8592 16.49 11.4892C16.5 9.00922 14.48 6.99922 12 6.99922C11.63 6.99922 11.28 7.04922 10.93 7.13922ZM2.01 3.86922L4.69 6.54922C3.06 7.82922 1.77 9.52922 1 11.4992C2.73 15.8892 7 18.9992 12 18.9992C13.52 18.9992 14.98 18.7092 16.32 18.1792L19.74 21.5992L21.15 20.1892L3.42 2.44922L2.01 3.86922ZM9.51 11.3692L12.12 13.9792C12.08 13.9892 12.04 13.9992 12 13.9992C10.62 13.9992 9.5 12.8792 9.5 11.4992C9.5 11.4492 9.51 11.4192 9.51 11.3692ZM6.11 7.96922L7.86 9.71922C7.63 10.2692 7.5 10.8692 7.5 11.4992C7.5 13.9792 9.52 15.9992 12 15.9992C12.63 15.9992 13.23 15.8692 13.77 15.6392L14.75 16.6192C13.87 16.8592 12.95 16.9992 12 16.9992C8.21 16.9992 4.83 14.8692 3.18 11.4992C3.88 10.0692 4.9 8.88922 6.11 7.96922Z"
            fill="#785CC7"
        />
    </svg>
)

export const IconWatches = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
        <rect width="40" height="40" fill="white" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 36C28.8366 36 36 28.8366 36 20C36 11.1634 28.8366 4 20 4C11.1634 4 4 11.1634 4 20C4 28.8366 11.1634 36 20 36Z"
            fill="#FD8D8D"
        />
        <path
            d="M20 12L20 22.5L27.5 17.5"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const TripleDotsIcon = ({ height = 20, color = '#D8D8D8' }) => (
    <svg width="4" height={height} viewBox="0 0 4 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 4C3.10457 4 4 3.10457 4 2C4 0.89543 3.10457 0 2 0C0.89543 0 0 0.89543 0 2C0 3.10457 0.89543 4 2 4Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 12C3.10457 12 4 11.1046 4 10C4 8.89543 3.10457 8 2 8C0.89543 8 0 8.89543 0 10C0 11.1046 0.89543 12 2 12Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 20C3.10457 20 4 19.1046 4 18C4 16.8954 3.10457 16 2 16C0.89543 16 0 16.8954 0 18C0 19.1046 0.89543 20 2 20Z"
            fill={color}
        />
    </svg>
)

export const ExitIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            d="M14.1667 6.66667L12.9917 7.84167L14.3083 9.16667H7.5V10.8333H14.3083L12.9917 12.15L14.1667 13.3333L17.5 10L14.1667 6.66667ZM4.16667 4.16667H10V2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H10V15.8333H4.16667V4.16667Z"
            fill="#FF5656"
        />
    </svg>
)

export const StatsIcon = ({ isLoading }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            d="M11.333 2.66797H13.333V13.3346H11.333V2.66797ZM3.33301 9.33463H5.33301V13.3346H3.33301V9.33463ZM7.33301 6.0013H9.33301V13.3346H7.33301V6.0013Z"
            fill={isLoading ? '' : '#787878'}
        />
    </svg>
)

export const OpenEyeIcon = ({ isLoading, color = '#787878' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            d="M8.00033 4.33333C10.527 4.33333 12.7803 5.75333 13.8803 8C12.7803 10.2467 10.5337 11.6667 8.00033 11.6667C5.46699 11.6667 3.22033 10.2467 2.12033 8C3.22033 5.75333 5.47366 4.33333 8.00033 4.33333ZM8.00033 3C4.66699 3 1.82033 5.07333 0.666992 8C1.82033 10.9267 4.66699 13 8.00033 13C11.3337 13 14.1803 10.9267 15.3337 8C14.1803 5.07333 11.3337 3 8.00033 3ZM8.00033 6.33333C8.92033 6.33333 9.66699 7.08 9.66699 8C9.66699 8.92 8.92033 9.66667 8.00033 9.66667C7.08033 9.66667 6.33366 8.92 6.33366 8C6.33366 7.08 7.08033 6.33333 8.00033 6.33333ZM8.00033 5C6.34699 5 5.00033 6.34667 5.00033 8C5.00033 9.65333 6.34699 11 8.00033 11C9.65366 11 11.0003 9.65333 11.0003 8C11.0003 6.34667 9.65366 5 8.00033 5Z"
            fill={isLoading ? '' : color}
        />
    </svg>
)

export const OpenInNewWindow = ({ isLoading, color = '#787878' }) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.6667 12.6667H3.33333V3.33333H8V2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.4 2.59333 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V8H12.6667V12.6667ZM9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2H9.33333Z"
            fill={isLoading ? '' : color}
        />
    </svg>
)

export const EditPencilIcon = ({ isLoading, color = '#787878' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            d="M11.7167 7.51667L12.4833 8.28333L4.93333 15.8333H4.16667V15.0667L11.7167 7.51667V7.51667ZM14.7167 2.5C14.5083 2.5 14.2917 2.58333 14.1333 2.74167L12.6083 4.26667L15.7333 7.39167L17.2583 5.86667C17.5833 5.54167 17.5833 5.01667 17.2583 4.69167L15.3083 2.74167C15.1417 2.575 14.9333 2.5 14.7167 2.5V2.5ZM11.7167 5.15833L2.5 14.375V17.5H5.625L14.8417 8.28333L11.7167 5.15833V5.15833Z"
            fill={isLoading ? '' : color}
        />
    </svg>
)

export const PhotoIcon = () => (
    <svg width="18" height="15" viewBox="0 0 18 15" fill="#none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.091 1.34886H12.219C12.1044 0.585393 11.4457 0 10.6502 0H7.3504C6.55498 0 5.89628 0.585393 5.78162 1.34886H1.90918C1.35689 1.34886 0.90918 1.79658 0.90918 2.34886V13.8337C0.90918 14.386 1.35689 14.8337 1.90918 14.8337H16.091C16.6433 14.8337 17.091 14.386 17.091 13.8337V2.34886C17.091 1.79658 16.6433 1.34886 16.091 1.34886ZM9 12.1366C11.2342 12.1366 13.0455 10.3254 13.0455 8.09114C13.0455 5.85689 11.2342 4.04568 9 4.04568C6.76576 4.04568 4.95455 5.85689 4.95455 8.09114C4.95455 10.3254 6.76576 12.1366 9 12.1366ZM8.9999 10.7883C10.4894 10.7883 11.6969 9.58078 11.6969 8.09129C11.6969 6.60179 10.4894 5.39432 8.9999 5.39432C7.51041 5.39432 6.30293 6.60179 6.30293 8.09129C6.30293 9.58078 7.51041 10.7883 8.9999 10.7883Z"
            fill="#979797"
            strokeLinejoin="round"
        />
    </svg>
)

export const PadlockInCircle = ({ color = '#787878' }) => (
    <svg width="24" height="24" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="22" cy="22" r="22" fill="white" />
        <path
            d="M29.2861 15.937H28.0514V13.3836C28.0514 9.85985 25.2856 7 21.8778 7C18.4699 7 15.7042 9.85985 15.7042 13.3836V15.937H14.4694C13.1112 15.937 12 17.0861 12 18.4905V31.2577C12 32.6621 13.1112 33.8111 14.4694 33.8111H29.2861C30.6443 33.8111 31.7555 32.6621 31.7555 31.2577V18.4905C31.7555 17.0861 30.6443 15.937 29.2861 15.937ZM21.8778 27.4275C20.5196 27.4275 19.4083 26.2785 19.4083 24.8741C19.4083 23.4697 20.5196 22.3206 21.8778 22.3206C23.236 22.3206 24.3472 23.4697 24.3472 24.8741C24.3472 26.2785 23.236 27.4275 21.8778 27.4275ZM25.7054 15.937H18.0501V13.3836C18.0501 11.2004 19.7664 9.42577 21.8778 9.42577C23.9891 9.42577 25.7054 11.2004 25.7054 13.3836V15.937Z"
            fill={color}
        />
    </svg>
)

export const GameControlIcon = ({ isLoading, color = '#787878', controlsColor = '#323232' }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1111_12603)">
            <path
                d="M2.01633 13.4077L2.92466 7.02435C3.15799 5.38268 4.56633 4.16602 6.22466 4.16602H13.7747C15.433 4.16602 16.8413 5.38268 17.0747 7.02435L17.983 13.4077C18.1663 14.691 17.1747 15.8327 15.883 15.8327C15.3163 15.8327 14.783 15.6077 14.383 15.2077L12.4997 13.3327H7.49966L5.62466 15.2077C5.22466 15.6077 4.68299 15.8327 4.12466 15.8327C2.82466 15.8327 1.83299 14.691 2.01633 13.4077ZM3.76633 14.0077C3.83299 14.0827 3.94133 14.166 4.11633 14.166C4.24133 14.166 4.35799 14.116 4.44133 14.0327L6.80799 11.666H13.1913L15.558 14.0327C15.6413 14.116 15.758 14.166 15.883 14.166C16.058 14.166 16.1663 14.0827 16.233 14.0077C16.2997 13.9327 16.3663 13.816 16.3413 13.641L15.433 7.25768C15.308 6.44935 14.5997 5.83268 13.7747 5.83268H6.22466C5.39966 5.83268 4.69133 6.44935 4.57466 7.26602L3.66633 13.6493C3.64133 13.816 3.70799 13.9327 3.76633 14.0077Z"
                fill={isLoading ? '' : color}
            />
            <path
                d="M12.5 6.66602H13.3333V8.33268H15V9.16602H13.3333V10.8327H12.5V9.16602H10.8333V8.33268H12.5V6.66602Z"
                fill={isLoading ? '' : controlsColor}
            />
            <path
                d="M5.83268 10.8327C5.37244 10.8327 4.99935 10.4596 4.99935 9.99935C4.99935 9.53911 5.37244 9.16602 5.83268 9.16602C6.29292 9.16602 6.66602 9.53911 6.66602 9.99935C6.66602 10.4596 6.29292 10.8327 5.83268 10.8327Z"
                fill={isLoading ? '' : controlsColor}
            />
            <path
                d="M7.49967 8.33268C7.03944 8.33268 6.66634 7.95959 6.66634 7.49935C6.66634 7.03911 7.03944 6.66602 7.49967 6.66602C7.95991 6.66602 8.33301 7.03911 8.33301 7.49935C8.33301 7.95959 7.95991 8.33268 7.49967 8.33268Z"
                fill={isLoading ? '' : controlsColor}
            />
        </g>
        <defs>
            <clipPath id="clip0_1111_12603">
                <rect width="20" height="20" fill="white" transform="matrix(-1 0 0 1 20 0)" />
            </clipPath>
        </defs>
    </svg>
)

export const ShareArrowIcon = ({ isLoading, color = '#787878' }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.1667 7.5013V7.93495L11.7374 7.99628C9.03728 8.382 7.10695 9.50419 5.73833 10.9925C4.75176 12.0654 4.04553 13.3415 3.55994 14.6956C5.60747 12.7914 8.2571 11.918 11.6667 11.918H12.1667V12.418V14.6275L16.7929 10.0013L12.1667 5.37508V7.5013Z"
            fill={isLoading ? '' : color}
            stroke={isLoading ? '' : color}
        />
    </svg>
)

export const SettingsIcon = ({ isLoading, color = '#787878' }) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.9533 8.65337C12.98 8.44004 13 8.22671 13 8.00004C13 7.77337 12.98 7.56004 12.9533 7.34671L14.36 6.24671C14.4867 6.14671 14.52 5.96671 14.44 5.82004L13.1067 3.51337C13.0467 3.40671 12.9333 3.34671 12.8133 3.34671C12.7733 3.34671 12.7333 3.35337 12.7 3.36671L11.04 4.03337C10.6933 3.76671 10.32 3.54671 9.91335 3.38004L9.66002 1.61337C9.64002 1.45337 9.50002 1.33337 9.33335 1.33337H6.66668C6.50002 1.33337 6.36002 1.45337 6.34002 1.61337L6.08668 3.38004C5.68002 3.54671 5.30668 3.77337 4.96002 4.03337L3.30002 3.36671C3.26002 3.35337 3.22002 3.34671 3.18002 3.34671C3.06668 3.34671 2.95335 3.40671 2.89335 3.51337L1.56001 5.82004C1.47335 5.96671 1.51335 6.14671 1.64002 6.24671L3.04668 7.34671C3.02002 7.56004 3.00002 7.78004 3.00002 8.00004C3.00002 8.22004 3.02002 8.44004 3.04668 8.65337L1.64002 9.75338C1.51335 9.85338 1.48001 10.0334 1.56001 10.18L2.89335 12.4867C2.95335 12.5934 3.06668 12.6534 3.18668 12.6534C3.22668 12.6534 3.26668 12.6467 3.30002 12.6334L4.96002 11.9667C5.30668 12.2334 5.68002 12.4534 6.08668 12.62L6.34002 14.3867C6.36002 14.5467 6.50002 14.6667 6.66668 14.6667H9.33335C9.50002 14.6667 9.64002 14.5467 9.66002 14.3867L9.91335 12.62C10.32 12.4534 10.6933 12.2267 11.04 11.9667L12.7 12.6334C12.74 12.6467 12.78 12.6534 12.82 12.6534C12.9333 12.6534 13.0467 12.5934 13.1067 12.4867L14.44 10.18C14.52 10.0334 14.4867 9.85338 14.36 9.75338L12.9533 8.65337V8.65337ZM11.6333 7.51338C11.66 7.72004 11.6667 7.86004 11.6667 8.00004C11.6667 8.14004 11.6533 8.28671 11.6333 8.48671L11.54 9.24004L12.1333 9.70671L12.8533 10.2667L12.3867 11.0734L11.54 10.7334L10.8467 10.4534L10.2467 10.9067C9.96002 11.12 9.68668 11.28 9.41335 11.3934L8.70668 11.68L8.60002 12.4334L8.46668 13.3334H7.53335L7.40668 12.4334L7.30002 11.68L6.59335 11.3934C6.30668 11.2734 6.04001 11.12 5.77335 10.92L5.16668 10.4534L4.46002 10.74L3.61335 11.08L3.14668 10.2734L3.86668 9.71337L4.46002 9.24671L4.36668 8.49337C4.34668 8.28671 4.33335 8.13337 4.33335 8.00004C4.33335 7.86671 4.34668 7.71338 4.36668 7.51338L4.46002 6.76004L3.86668 6.29337L3.14668 5.73337L3.61335 4.92671L4.46002 5.26671L5.15335 5.54671L5.75335 5.09337C6.04002 4.88004 6.31335 4.72004 6.58668 4.60671L7.29335 4.32004L7.40002 3.56671L7.53335 2.66671H8.46002L8.58668 3.56671L8.69335 4.32004L9.40002 4.60671C9.68668 4.72671 9.95335 4.88004 10.22 5.08004L10.8267 5.54671L11.5333 5.26004L12.38 4.92004L12.8467 5.72671L12.1333 6.29337L11.54 6.76004L11.6333 7.51338ZM8.00002 5.33337C6.52668 5.33337 5.33335 6.52671 5.33335 8.00004C5.33335 9.47338 6.52668 10.6667 8.00002 10.6667C9.47335 10.6667 10.6667 9.47338 10.6667 8.00004C10.6667 6.52671 9.47335 5.33337 8.00002 5.33337ZM8.00002 9.33337C7.26668 9.33337 6.66668 8.73337 6.66668 8.00004C6.66668 7.26671 7.26668 6.66671 8.00002 6.66671C8.73335 6.66671 9.33335 7.26671 9.33335 8.00004C9.33335 8.73337 8.73335 9.33337 8.00002 9.33337Z"
            fill={isLoading ? '' : color}
        />
    </svg>
)

export const TipBulb = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.8282 11.225C11.0908 12.2082 10.8611 13.5393 11.0772 14.8356C11.2654 15.9649 11.696 16.7664 12.2183 17.6154C12.287 17.7271 12.3585 17.8411 12.4317 17.958C12.9058 18.7147 13.4531 19.5882 13.8047 20.698C13.9714 21.2245 13.6799 21.7865 13.1534 21.9533C12.6269 22.1201 12.0648 21.8285 11.898 21.302C11.6285 20.4511 11.2248 19.8036 10.7492 19.0409C10.6729 18.9185 10.5946 18.793 10.5148 18.6633C9.94653 17.7395 9.35621 16.6753 9.10437 15.1644C8.82038 13.4607 9.09063 11.5418 10.2282 10.025C11.3906 8.47527 13.3412 7.5 16.0908 7.5C16.643 7.5 17.0908 7.94772 17.0908 8.5C17.0908 9.05228 16.643 9.5 16.0908 9.5C13.8404 9.5 12.5409 10.2747 11.8282 11.225Z"
            fill="#FFC451"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.2626 11.225C21 12.2082 21.2297 13.5393 21.0137 14.8356C20.8118 16.0465 20.3506 16.9888 19.8063 18.0116C19.7582 18.1019 19.7093 18.1932 19.6598 18.2855C19.1581 19.2214 18.595 20.2717 18.2665 21.5651C18.2581 21.5978 18.2425 21.6211 18.2299 21.6336C18.2245 21.6389 18.221 21.6412 18.2193 21.6421L13.4122 22.5161C12.8688 22.6149 12.5084 23.1355 12.6072 23.6789C12.706 24.2223 13.2266 24.5827 13.77 24.4839L18.5781 23.6097C19.4245 23.4558 20.0168 22.798 20.2049 22.0575C20.4705 21.0119 20.9208 20.1696 21.434 19.2094C21.4795 19.1244 21.5254 19.0384 21.5718 18.9513C22.132 17.8986 22.728 16.715 22.9864 15.1644C23.2704 13.4607 23.0002 11.5418 21.8626 10.025C20.7003 8.47527 18.7497 7.5 16.0001 7.5C15.4478 7.5 15.0001 7.94772 15.0001 8.5C15.0001 9.05228 15.4478 9.5 16.0001 9.5C18.2505 9.5 19.5499 10.2747 20.2626 11.225ZM18.2182 21.6426C18.2182 21.6426 18.2185 21.6425 18.2191 21.6422L18.2182 21.6426Z"
            fill="#FFC451"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.0257 25.5122C18.9269 24.9688 18.4063 24.6084 17.8629 24.7072L14.4119 25.3347C13.8685 25.4335 13.5081 25.9541 13.6069 26.4974C13.7057 27.0408 14.2263 27.4012 14.7697 27.3024L18.2207 26.675C18.7641 26.5762 19.1245 26.0556 19.0257 25.5122Z"
            fill="#FFC451"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.3245 28.8213C17.2257 28.2779 16.7051 27.9175 16.1618 28.0163L15.8714 28.0691C15.328 28.1679 14.9676 28.6885 15.0664 29.2319C15.1652 29.7752 15.6858 30.1356 16.2292 30.0368L16.5195 29.984C17.0629 29.8852 17.4233 29.3647 17.3245 28.8213Z"
            fill="#FFC451"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 5L15 3C15 2.44772 15.4477 2 16 2C16.5523 2 17 2.44772 17 3L17 5C17 5.55228 16.5523 6 16 6C15.4477 6 15 5.55228 15 5Z"
            fill="#FFC451"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 15C8 15.5523 7.55228 16 7 16H5C4.44772 16 4 15.5523 4 15C4 14.4477 4.44772 14 5 14H7C7.55228 14 8 14.4477 8 15Z"
            fill="#FFC451"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.70696 6.2928C7.09748 5.90228 7.73064 5.90228 8.12117 6.2928L9.62117 7.7928C10.0117 8.18332 10.0117 8.81649 9.62117 9.20701C9.23065 9.59754 8.59748 9.59754 8.20696 9.20701L6.70696 7.70701C6.31643 7.31649 6.31643 6.68332 6.70696 6.2928Z"
            fill="#FFC451"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.29304 23.293C6.90252 22.9025 6.90252 22.2694 7.29304 21.8788L8.79304 20.3788C9.18357 19.9883 9.81673 19.9883 10.2073 20.3788C10.5978 20.7694 10.5978 21.4025 10.2073 21.793L8.70726 23.293C8.31673 23.6836 7.68357 23.6836 7.29304 23.293Z"
            fill="#FFC451"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17 5L17 3C17 2.44772 16.5523 2 16 2C15.4477 2 15 2.44772 15 3L15 5C15 5.55228 15.4477 6 16 6C16.5523 6 17 5.55228 17 5Z"
            fill="#FFC451"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24 15C24 15.5523 24.4477 16 25 16H27C27.5523 16 28 15.5523 28 15C28 14.4477 27.5523 14 27 14H25C24.4477 14 24 14.4477 24 15Z"
            fill="#FFC451"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.293 6.2928C24.9025 5.90228 24.2694 5.90228 23.8788 6.2928L22.3788 7.7928C21.9883 8.18332 21.9883 8.81649 22.3788 9.20701C22.7694 9.59754 23.4025 9.59754 23.793 9.20701L25.293 7.70701C25.6836 7.31649 25.6836 6.68332 25.293 6.2928Z"
            fill="#FFC451"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.707 23.293C25.0975 22.9025 25.0975 22.2694 24.707 21.8788L23.207 20.3788C22.8164 19.9883 22.1833 19.9883 21.7927 20.3788C21.4022 20.7694 21.4022 21.4025 21.7927 21.793L23.2927 23.293C23.6833 23.6836 24.3164 23.6836 24.707 23.293Z"
            fill="#FFC451"
        />
    </svg>
)

export const IconLimit = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
        <rect width="40" height="40" fill="white" />
        <mask id="path-2-inside-1_212_4981" fill="white">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M36 25H30C30 19.4772 25.5228 15 20 15C14.4772 15 10 19.4772 10 25H4C4 16.1634 11.1634 9 20 9C28.8366 9 36 16.1634 36 25Z"
            />
        </mask>
        <path
            d="M30 25H29V26H30V25ZM36 25V26H37V25H36ZM10 25V26H11V25H10ZM4 25H3V26H4V25ZM30 26H36V24H30V26ZM31 25C31 18.9249 26.0751 14 20 14V16C24.9706 16 29 20.0294 29 25H31ZM20 14C13.9249 14 9 18.9249 9 25H11C11 20.0294 15.0294 16 20 16V14ZM4 26H10V24H4V26ZM20 8C10.6112 8 3 15.6112 3 25H5C5 16.7157 11.7157 10 20 10V8ZM37 25C37 15.6112 29.3888 8 20 8V10C28.2843 10 35 16.7157 35 25H37Z"
            fill="#FD8D8D"
            mask="url(#path-2-inside-1_212_4981)"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.9995 25H35.9995C35.9995 22.2138 35.2874 19.5939 34.0352 17.3125L28.8486 20.338C29.5835 21.73 29.9995 23.3164 29.9995 25Z"
            fill="#FD8D8D"
        />
        <path
            d="M34.8937 15.948C34.9194 15.9377 34.9355 15.9363 34.9433 15.9363C34.9511 15.9363 34.9572 15.9377 34.9631 15.94C34.9763 15.9455 34.9977 15.9609 35.0142 15.9909C35.0308 16.021 35.0324 16.0473 35.0299 16.0614C35.0288 16.0677 35.0267 16.0735 35.0225 16.0802C35.0183 16.0867 35.0085 16.0996 34.986 16.1157L21.0382 26.1326C19.9858 26.8884 18.5094 26.5545 17.8846 25.4194C17.2598 24.2842 17.7676 22.8582 18.9691 22.3734L34.8937 15.948Z"
            fill="#FD8D8D"
            stroke="white"
        />
    </svg>
)

export const IconPlay = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M17.7519 11.168C18.3457 11.5639 18.3457 12.4363 17.7519 12.8321L8.55469 18.9636C7.89014 19.4066 7 18.9302 7 18.1315L7 5.86853C7 5.06983 7.89015 4.59344 8.5547 5.03648L17.7519 11.168Z"
            fill="currentColor"
        />
    </svg>
)

export const IconPause = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M6 19H10V5H6V19ZM14 5V19H18V5H14Z" fill="currentColor" />
    </svg>
)

export const IconStepRewind = ({ skipValue }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M11.99 5V1L6.98999 6L11.99 11V7C15.3 7 17.99 9.69 17.99 13C17.99 16.31 15.3 19 11.99 19C8.67999 19 5.98999 16.31 5.98999 13H3.98999C3.98999 17.42 7.56999 21 11.99 21C16.41 21 19.99 17.42 19.99 13C19.99 8.58 16.41 5 11.99 5ZM10.89 16H10"
            fill="#3C3C3C"
        />
        <text
            xmlns="http://www.w3.org/2000/svg"
            fontFamily="Roboto, sans-serif"
            fontWeight="700"
            fontSize="7"
            y="16"
            x="8"
            fill="currentColor"
        >
            {skipValue}
        </text>
    </svg>
)

export const IconStepForward = ({ skipValue }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M18 13C18 16.31 15.31 19 12 19C8.69 19 6 16.31 6 13C6 9.69 8.69 7 12 7V11L17 6L12 1V5C7.58 5 4 8.58 4 13C4 17.42 7.58 21 12 21C16.42 21 20 17.42 20 13H18Z"
            fill="currentColor"
        />
        <text
            xmlns="http://www.w3.org/2000/svg"
            fontFamily="Roboto, sans-serif"
            fontWeight="700"
            fontSize="7"
            y="16"
            x="8"
            fill="currentColor"
        >
            {skipValue}
        </text>
    </svg>
)

export const IconVolume = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M3 8.99998V15H7L12 20V3.99998L7 8.99998H3ZM10 8.82998V15.17L7.83 13H5V11H7.83L10 8.82998ZM16.5 12C16.5 10.23 15.48 8.70998 14 7.96998V16.02C15.48 15.29 16.5 13.77 16.5 12ZM14 3.22998V5.28998C16.89 6.14998 19 8.82998 19 12C19 15.17 16.89 17.85 14 18.71V20.77C18.01 19.86 21 16.28 21 12C21 7.71998 18.01 4.13998 14 3.22998Z"
            fill="currentColor"
        />
    </svg>
)

export const IconMute = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M4.33999 2.93018L2.92999 4.34018L7.28999 8.70018L6.99999 9.00018H2.99999V15.0002H6.99999L12 20.0002V13.4102L16.18 17.5902C15.53 18.0802 14.8 18.4702 14 18.7002V20.7602C15.34 20.4602 16.57 19.8402 17.61 19.0102L19.66 21.0602L21.07 19.6502L4.33999 2.93018ZM9.99999 15.1702L7.82999 13.0002H4.99999V11.0002H7.82999L8.70999 10.1202L9.99999 11.4102V15.1702ZM19 12.0002C19 12.8202 18.85 13.6102 18.59 14.3402L20.12 15.8702C20.68 14.7002 21 13.3902 21 12.0002C21 7.72018 18.01 4.14018 14 3.23018V5.29018C16.89 6.15018 19 8.83018 19 12.0002ZM12 4.00018L10.12 5.88018L12 7.76018V4.00018ZM16.5 12.0002C16.5 10.2302 15.48 8.71018 14 7.97018V9.76018L16.48 12.2402C16.49 12.1602 16.5 12.0802 16.5 12.0002Z"
            fill="currentColor"
        />
    </svg>
)

export const IconNextAudio = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M16 18h2V6h-2M6 18l8.5-6L6 6v12z" fill="currentColor" />
    </svg>
)

export const IconPreviousAudio = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M6 18V6h2v12H6m3.5-6L18 6v12l-8.5-6z" fill="currentColor" />
    </svg>
)

export const IconRepeatAudio = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M7 7H17V10L21 6L17 2V5H5V11H7V7ZM17 17H7V14L3 18L7 22V19H19V13H17V17Z" fill="currentColor" />
    </svg>
)

export const IconRepeatOffAudio = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M2 5.27L3.28 4L20 20.72L18.73 22l-3-3H7v3l-4-4l4-4v3h6.73L7 10.27V11H5V8.27l-3-3M17 13h2v4.18l-2-2V13m0-8V2l4 4l-4 4V7H8.82l-2-2H17z"
            fill="currentColor"
        />
    </svg>
)

export const IconMusicalNote = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            d="M10 2.5V11.2917C9.50833 11.0083 8.94167 10.8333 8.33333 10.8333C6.49167 10.8333 5 12.325 5 14.1667C5 16.0083 6.49167 17.5 8.33333 17.5C10.175 17.5 11.6667 16.0083 11.6667 14.1667V5.83333H15V2.5H10ZM8.33333 15.8333C7.41667 15.8333 6.66667 15.0833 6.66667 14.1667C6.66667 13.25 7.41667 12.5 8.33333 12.5C9.25 12.5 10 13.25 10 14.1667C10 15.0833 9.25 15.8333 8.33333 15.8333Z"
            fill="currentColor"
        />
    </svg>
)

export const IconFolder = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0 1.57129C0 1.019 0.447715 0.571289 1 0.571289H4.4593C4.79669 0.571289 5.11133 0.741414 5.29607 1.02373L6.45393 2.79314C6.63867 3.07545 6.95331 3.24557 7.2907 3.24557H15C15.5523 3.24557 16 3.69329 16 4.24557V11.4284C16 13.6376 14.2091 15.4284 12 15.4284H4C1.79086 15.4284 0 13.6376 0 11.4284V1.57129Z"
                fill="#416FF2"
            />
            <path d="M1.5 2.05713H5.40625H6.77344H14V9.23808H1.5V2.05713Z" fill="#ECF0F3" />
            <path
                d="M0 3.29492H5H6.75H15C15.5523 3.29492 16 3.74264 16 4.29492V14.4283C16 14.9805 15.5523 15.4283 15 15.4283H1C0.447715 15.4283 0 14.9805 0 14.4283V3.29492Z"
                fill="#5694F7"
            />
        </svg>
    )
}

export const IconCrown = ({ isLoading, color = '#787878' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            d="M2.19868 6.06554L3.643 12.3563C3.68472 12.538 3.84643 12.6668 4.03286 12.6668H11.9671C12.1536 12.6668 12.3153 12.538 12.357 12.3563L13.8013 6.06554C13.8784 5.72959 13.5229 5.45991 13.2202 5.62472L10.5714 7.06683L8.32942 3.81177C8.17045 3.58096 7.82955 3.58096 7.67058 3.81177L5.42857 7.06683L2.77981 5.62472C2.47708 5.45991 2.12155 5.72959 2.19868 6.06554Z"
            stroke={isLoading ? '' : color}
            strokeWidth="2"
        />
    </svg>
)

export const IconController = ({ color = '#65bb5a' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" height="48px" version="1.1" viewBox="0 0 48 48" width="48px">
        <g id="Layer_3">
            <path
                d="M47.641,31.641l0.008-0.002L44.369,17.82c-0.057-0.307-0.129-0.606-0.213-0.901l-0.03-0.122l0,0   c-1.262-4.25-5.189-7.354-9.849-7.354c-2.101,0-4.053,0.633-5.68,1.714H19.4c-1.626-1.081-3.578-1.714-5.676-1.714   c-5.12,0-9.354,3.75-10.136,8.647H3.58L0.224,32.064c-0.042,0.16-0.086,0.318-0.114,0.48l-0.031,0.129l0.016,0.016   c-0.035,0.242-0.074,0.48-0.074,0.73c0,2.84,2.3,5.139,5.138,5.139c1.291,0,2.456-0.49,3.353-1.279l0.001,0.004l9.047-7.43h12.888   l8.791,7.164c0.254,0.258,0.539,0.49,0.846,0.691l0.155,0.125v-0.031c0.762,0.463,1.638,0.756,2.597,0.756   c2.84,0,5.142-2.299,5.142-5.139C47.979,32.791,47.85,32.197,47.641,31.641z M34.77,13.142c1.263,0,2.282,1.023,2.282,2.284   c0,1.265-1.02,2.286-2.282,2.286c-1.266,0-2.286-1.021-2.286-2.286C32.483,14.166,33.504,13.142,34.77,13.142z M20.165,19.928   c0,1.263-1.021,2.286-2.284,2.286h-2.287v2.284c0,1.261-1.021,2.285-2.284,2.285c-1.264,0-2.287-1.023-2.287-2.285v-2.284H8.738   c-1.264,0-2.286-1.023-2.286-2.286l0,0c0-1.263,1.022-2.286,2.286-2.286h2.284v-2.284c0-1.264,1.022-2.286,2.287-2.286   c1.263,0,2.284,1.022,2.284,2.286v2.284h2.287C19.143,17.642,20.165,18.666,20.165,19.928L20.165,19.928z M30.1,22.283   c-1.263,0-2.282-1.023-2.282-2.286s1.02-2.286,2.282-2.286c1.266,0,2.285,1.023,2.285,2.286S31.365,22.283,30.1,22.283z    M34.77,26.854c-1.266,0-2.286-1.023-2.286-2.287c0-1.261,1.021-2.284,2.286-2.284c1.263,0,2.282,1.023,2.282,2.284   C37.052,25.83,36.032,26.854,34.77,26.854z M39.338,22.283c-1.263,0-2.286-1.023-2.286-2.286s1.023-2.286,2.286-2.286   c1.267,0,2.286,1.023,2.286,2.286S40.604,22.283,39.338,22.283z"
                fill={color}
            />
        </g>
    </svg>
)
